import { render, staticRenderFns } from "./view02.vue?vue&type=template&id=290d8f12&scoped=true"
import script from "./view02.vue?vue&type=script&lang=js"
export * from "./view02.vue?vue&type=script&lang=js"
import style0 from "./view02.vue?vue&type=style&index=0&id=290d8f12&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d8f12",
  null
  
)

export default component.exports